<template>
      <div class="file">
        <div class="file-view">

          <v-row>
            <v-col>
              <div class="file-view__name">
                {{item.name}}
                <button v-if="item.fileServerID" class="file-view__download-file" @click="getFile">просмотр файла
                  <v-progress-circular
                      v-if="uploadNow"
                      indeterminate
                      color="#eb722e"
                      size="10"
                      width="2"
                  ></v-progress-circular>
                </button>
              </div>
              <div class="file-view__date">
                <span v-if="item.fileServerID">Дата загрузки: {{uploadFileDate}}</span>
                <span v-else>Необходимо загрузить</span>
              </div>
            </v-col>
            <v-col>
              <div class="file-view__actions">
                <button v-if="(!modeEdit && get_blockedAll && false) && authData.userProfile > 0" class="button_border file-view__button_replace" :class="{'button_border_important' : !item.fileServerID}" @click="modeEdit = !modeEdit">{{item.fileServerID ? 'Заменить' : 'Загрузить'}}</button>
              </div>
              <div class="file-edit" v-if="modeEdit && get_blockedAll">
                <v-file-input label="Выбрать файл..." v-model="fileToUpload" :accept="typesFiles"  :rules="rules"/>
                <button
                    class="button_border button_border border_margin_right"
                    @click="uploadFile"
                    :disabled="!canUpload || uploadToServNow"
                >Загрузить
                  <v-progress-circular
                      v-if="uploadToServNow"
                      indeterminate
                      color="#eb722e"
                      size="10"
                      width="2"
                  ></v-progress-circular>
                </button>
                <button class="button_border" @click="modeEdit = !modeEdit">Отмена</button>
              </div>
            </v-col>
          </v-row>
        </div>

        
    </div>
</template>
<script>
import {mapGetters} from 'vuex';
import moment from 'moment'
moment.locale('ru');
import saveFile from '@/utils/saveFile';
import request from "@/services/request";
export default {
    props: {
        item: {
            type: Object,
        }
    },
    data() {
        return {
            fileToUpload: null,
            modeEdit: false,
            uploadNow: false,
            uploadToServNow: false,
            rules: [
            value => !value || value.size < 20000000 || 'Размер файла не должен превышать 20 МБ!',
            ],
            canUpload: true,
        }
    },
    computed: {
        ...mapGetters('auth', {get_blockedAll: 'get_blockedAll', authData: 'authData'}),
        uploadFileDate() {
                return moment(this.item.uploadDate).format('LLL');  
        },
      typesFiles(){
          return this.item.types.join(',')
      }
    },
    methods: {
        uploadFile: function() {
          if (this.fileToUpload.size < 20000000)
          {
            this.uploadToServNow = true;
            if (this.fileToUpload) {
              if (this.item.fileServerID) {
                this.$emit('replaceFile', {'fileType': this.item.fileType, 'file': this.fileToUpload, 'id': this.item.id});
              } else {
                this.$emit('uploadFile', {'fileType': this.item.fileType, 'file': this.fileToUpload});
              }
            
            }
          }
          else
            this.canUpload =false
        },
        async getFile() {
            this.uploadNow = true;
            let response = await request({
                endpoint: '/api/fileServer/downloadFileByID',
                method: 'POST',
                body: {
                    fileServerID: this.item.fileServerID,
                    fileName: this.item.fileName,
                    fileFormat: this.item.fileFormat,
                    }
            });
            this.uploadNow = false;
        saveFile(response.data);
    },
    },
}
</script>